export default __webpack_public_path__ + "static/media/CoffeeLogo.97e32efe.svg";